import React from 'react';
import FormReplyComment from './FormReplyComment';
import Helper from './Helper';
import ProductCommentChild from './ProductCommentChild';

class CommentItem extends React.Component {
    constructor(props)
    {
        super(props);
        this.state = {
            isShowFormReply:false,
            isShowChild: false
        }
    }

    handleShowReply=(isShowFormReply)=>{
        let {account} = this.props;
        if(!account)
        {
            window.location.href = '/dang-nhap/?redirect='+encodeURIComponent(window.location.href);
            return false;
        }
        this.setState({isShowFormReply:isShowFormReply})
    }
    handleShowChild = (e)=>{
        e.preventDefault();
        let {isShowChild} = this.state;
        e.target.text = isShowChild ? "Xem tất cả trả lời ...":"Ẩn tất cả trả lời";
        this.setState({
            isShowChild:!isShowChild
        })
    }
    render(){
        let {review, account, product} = this.props;
        let {rating} = review,
        {isShowFormReply} = this.state,
        rating_view = [];
        for (let i = 0; i < 5; i++) {
            let grayscale = rating <= i ? 'grayscale':''
            rating_view.push(
            <img key={i}
                src={Helper.getSiteUrl() + "/resource/images/ico_star_yellow.svg"}
                style={{width:'14px'}}
                className={`rating ${grayscale}`}
            />);
        }
        let commentChild = review.child && review.child.length ? review.child.map((item, index)=>{
            return (
            <ProductCommentChild key={index} topReview={review} review={item} account={account} product={product}
            handleShowReply={this.handleShowReply} />
            );
        }):[];
        return (
            <li className="row">
                <div className="col-sm-2 col-12 review-content__name text-center">
                    <img src={Helper.getSiteUrl() + "/resource/images/avatar_men.png"}
                    className="img-fluid d-block mx-auto" style={{width:'85px'}}/>
                    <span className="text-name">{review.name}</span>
                </div>
                <div className="col-sm-10 col-12 review-content__detail">
                    <p className="p-0 m-0 review-content__detail__title">{review.title}</p>
                    <div className="review-content__rating">{rating_view}</div>
                    <p className="pb-1 m-0 review-content__detail__small">{review.time}</p>
                    <div className="review-content__detail__text">
                        {review.des}
                        {review.id &&
                        <p className="review-block-action mb-2">
                            <button className="mr-3" onClick={()=>this.handleShowReply(true)}><i className="fas fa-reply" /> Trả lời</button>
                            {isShowFormReply ? 
                            <button onClick={()=>this.handleShowReply(false)}><i className="fas fa-times" /> Đóng</button>
                            :null}    
                        </p>
                        }
                        {review.child && review.child.length ? <p><a href="/" onClick={(e)=>this.handleShowChild(e)}>
                            Xem tất cả trả lời ...</a></p> : null}
                        {isShowFormReply &&
                        <FormReplyComment review={review} handleShowReply={this.handleShowReply} 
                        product={product} account={account} replyTo={review.id} />
                        }
                    </div>
                </div>
                <div className="col-12">
                    {review.child && review.child.length && this.state.isShowChild ?
                    <div className="comment-child-list bg-light">
                        <ul className="unstyled p-3">
                            {commentChild}
                        </ul>
                    </div>
                    :null}    
                </div>        
            </li>
        )
    }
}
export default CommentItem;